



// mcs scripts



// WINDOW SCROLLED
$(window).scroll(function() {  
  
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 800) {
      $("body").addClass("scrolled2");
  } else {
      $("body").removeClass("scrolled2");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }


  
});




$(document).ready(function(){

  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');
  }, 3000);





  var tempElement = $('<div class="mcs-sticky-add">').append($('.mcs-sticky-add-simple'));
  // Append the temporary element to the body
  $('body').append(tempElement);
  


  $('.chef-carousel').slick({
    rtl: false,
    appendArrows: true,
    slidesToShow: 3
  });





  $('.recipient-checkbox').click(function() { 
    $(this).toggleClass('active');
    $('.recipient-fields').toggleClass('active');
  });







  // cart toggles
  $('.mcs-cart-toggle').click(function() { 
    $('.mcs-cart-wrap').toggleClass('active');
    $('.mcs-cart-overlay').toggleClass('active');
  });
  $('.mcs-close-cart').click(function() { 
    $('.mcs-cart-wrap').removeClass('active');
    $('.mcs-cart-overlay').removeClass('active');
  });
  $('.mcs-cart-overlay').click(function() { 
    $(this).removeClass('active');
    $('.mcs-cart-wrap').removeClass('active');
  });


  $('.mcs-new-add-to-cart').click(function() { 
    setTimeout(function(){
      $('.mcs-cart-wrap').toggleClass('active');
      $('.mcs-cart-overlay').toggleClass('active');
    }, 500);
  });

  $('.mcs-cart-note-expander').click(function() { 
    $(this).toggleClass('active');
    $(this).siblings().toggleClass('active');
  });






  $('select.mcs-upsell-selector').change(function() {
      var optionSelected = $(this).find("option:selected");
      var dataimg = optionSelected.data("img");
      // var datatitle = optionSelected.data("title");
      console.log(dataimg);
      // console.log(datatitle);
      var parent = $(this).parent().parent('.mcs-upsell-product');
      $(parent).children().children('.upsell-variant-imgs-'+ dataimg).siblings().hide();
      $(parent).children().children('.upsell-variant-imgs-'+ dataimg).show();
  });


  if ($(".mcs-item-title:contains('bowl')").length > 0) {
    $('.product-type-bowls').hide();
    }
    if ($(".mcs-item-title:contains('plate')").length > 0) {
      $('.product-type-plates').hide();
    }
    if ($(".mcs-item-title:contains('cup')").length > 0) {
      $('.product-type-cafe').hide();
    }
    if ($(".mcs-item-title:contains('cafe')").length > 0) {
      $('.product-type-cafe').hide();
    }
    if ($(".mcs-item-title:contains('mug')").length > 0) {
      $('.product-type-cafe').hide();
    }
    if ($(".mcs-item-title:contains('bundle')").length > 0) {
      $('.product-type-bundles').hide();
    }
    if ($(".mcs-item-title:contains('vase')").length > 0) {
      $('.product-type-home-accessories').hide();
    }
    if ($(".mcs-item-title:contains('vase')").length > 0) {
      $('.product-type-special-edition').hide();
    }
    if ($(".mcs-item-title:contains('set')").length > 0) {
      $('.product-type-special-edition').hide();
    }


  




  // toggle prodshop button forms on load
  $('.proshop-catalogs-links').hide();
  var random = Math.floor(Math.random() * $('.proshop-catalogs-links').length);
  $('.proshop-catalogs-links').hide().eq(random).show();


  // maxwell lazy load script
  // Get all images with the class "lazyload"
  const mcslazyImages = document.querySelectorAll('.mcs-lazyload');

  // Create a new IntersectionObserver instance
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Replace the src attribute with the data-src attribute
        entry.target.src = entry.target.dataset.src;
        // Unobserve the image to avoid loading it multiple times
        observer.unobserve(entry.target);
      }
    });
  });

  // Observe each lazy image
    mcslazyImages.forEach(img => {
    observer.observe(img);
  });




  $('.accordion-list > li > .answer').hide();

  $('.accordion-list > li .question-wrap').click(function() {
    if ( $(this).parent().hasClass("active") ) {
      
      $(this).parent().siblings().removeClass("active").find(".answer").slideUp();
      $(this).parent().removeClass("active").find(".answer").slideUp();  

    } else {

      $(this).parent().siblings().removeClass("active").find(".answer").slideUp();
      $(this).parent().addClass("active").find(".answer").slideDown();
    }
    return false
  });


  // get tallest tab__content element
  let height = -1;
  $('.tab__content').each(function() {
    height = height > $(this).outerHeight() ? height : $(this).outerHeight();
       $(this).css('position', 'absolute');
  });
    
    // set height of tabs + top offset
  $('[data-tabs]').css('min-height', height + 40 + 'px');




  $('.reg-slider .dots').click(function(event) {
    //console.log('tf');

    event.preventDefault();
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
  });





  // help modal clicks
  $('.giftreggie-item-name').click(function( event ) {
    event.preventDefault();
    $('.mcs-gift-modal').addClass('active');

    $('.giftreggie-item-name').off('click');
  });
  $('.giftreggie-item-image').click(function( event ) {
    event.preventDefault();
    $('.mcs-gift-modal').addClass('active');

    $('.giftreggie-item-image').off('click');
  });
  $('.mcs-reg-prod-link').click(function( event ) {
    event.preventDefault();
    $('.mcs-gift-modal').addClass('active');

    $('.mcs-reg-prod-link').off('click');
  });

  $('.ok-btn').click(function( event ) {
    event.preventDefault();
    $('.mcs-gift-modal').removeClass('active');
  });





  $('.minus').click(function () {
    var $input = $(this).parent().find('input');
    var count = parseInt($input.val()) - 1;
    count = count < 1 ? 1 : count;
    $input.val(count);
    $input.change();
    return false;
  });
  $('.plus').click(function () {
    var $input = $(this).parent().find('input');
    $input.val(parseInt($input.val()) + 1);
    $input.change();
    return false;
  });




  // maxwell product hovers
  $('.mcs-single-prod-hover').hover(function() {
    $(this).addClass('active');
  }, function() {
    $(this).removeClass('active');
  });


  setTimeout(function(){
    $('.product-single__media-group').addClass('loaded');
  }, 200); 

  // single product page variant swatch main image hovers
  $('.mcs-single-prod-hover .mcs-product-hover').css({ "opacity": "0", "visiblity": "hidden" });
  var loaded_var = $('.loaded-var').attr("data-loaded-var");
  //console.log(loaded_var);
  $('.mcs-single-prod-hover .mcs-product-hover.current-var-'+loaded_var+'').css({ "opacity": "1", "visiblity": "visible" });

  // check if there is no current variant ... if no display the first variant image
  if ( $('.loaded-var').attr("data-loaded-var") !== "") {
    //console.log('i am not empty!!');
  } else {
    //console.log('i am empty!!');
    $('.mcs-single-prod-hover .mcs-product-hover.variant-0').css({ "opacity": "1", "visiblity": "visible" });
  }





  // label query 
  $('.mcs-label-query').click(function() {
    var curr_var = $(this).attr("data-var");
    console.log(curr_var);

    $('.vs-shipping .vs-'+curr_var+'').siblings().removeClass('active');
    $('.vs-shipping .vs-'+curr_var+'').addClass('active');

    $('.mcs-single-prod-hover .mcs-product-hover').css({ "opacity": "0", "visiblity": "hidden" });
    $('.mcs-single-prod-hover .'+curr_var+'').css({ "opacity": "1", "visiblity": "visible" });

    // for images load in glitch
    $('.product-single__media-group').removeClass('loaded');
    setTimeout(function(){
      $('.product-single__media-group').addClass('loaded');
    }, 200); 


    // pre-order hack
    if ( $(this).hasClass('mcs-preorder-copy') ) {
      // console.log("i am pre-order");
      $('.mcs-preorder-note').text("( PRE-ORDER )");
    } else {
      $('.mcs-preorder-note').text("");
    }

 

  });





  $('.mcs-hide-registry').click(function() {
    $('.pdp-registry-bar').hide();
  });
  $('.mcs-show-registry').click(function() {
    $('.pdp-registry-bar').css('display', 'flex');
  });






  $('.mcs-stamping-expand').click(function() {
    $(this).toggleClass('active');
    $('.option-name-custom-back-stamping').toggleClass('active');
  });



  // custom quantity
  // $('.qty-collection-pro-shop .mcs-new-qty').attr({
  //      "min" : 48   // values (or variables) here
  // });

  var currentVal = parseInt($('.qty-collection-pro-shop .mcs-new-qty').val());
  if (currentVal == 24) {
    $('.qty-collection-pro-shop .minus').hide();
  }
  if (currentVal < 24) {
    $('.qty-collection-pro-shop .minus').hide();
  }


  $('.qty-collection-pro-shop  .plus').click(function() {
      var currentVal = parseInt($(this).prev('.mcs-new-qty').val());

      if ( $('.qty-collection-pro-shop  .minus').hasClass('lower-min') ) {
        var minValue = 24;
      } else {
        var minValue = 24;
      }

      if (currentVal != NaN) {
        $(this).prev('.mcs-new-qty').val(currentVal - 1 + 6);
      }
      if (currentVal == minValue) {
        $('.qty-collection-pro-shop  .minus').hide();
      }
      if (currentVal > minValue) {
        $('.qty-collection-pro-shop  .minus').show();
      }

      console.log(currentVal);
      console.log(minValue);

  });

  $('.qty-collection-pro-shop  .minus').click(function() {
      var currentVal = parseInt($(this).next('.mcs-new-qty').val());

      
      if ( $('.qty-collection-pro-shop  .minus').hasClass('lower-min') ) {
        var minValue = 24;
      } else {
        var minValue = 24;
      }
      

      if (currentVal != NaN) {
          $(this).next('.mcs-new-qty').val(currentVal + 1 - 6);
      }
      if (currentVal < minValue) {
        $(this).next('.mcs-new-qty').val(minValue);
      }
      if (currentVal == minValue) {
        $('.qty-collection-pro-shop  .minus').hide();
      }
      if (currentVal < minValue) {
        $('.qty-collection-pro-shop  .minus').hide();
      }

      console.log(currentVal);
      console.log(minValue);
  });



    // for glazes only
  $('.mcs-label-query-glaze').click(function() {

    if ( $(this).hasClass('pro-shop-white') ) {
      // console.log('its white!');
      $('.qty-collection-pro-shop .mcs-new-qty').attr({ "min" : 24 });
      $('.qty-collection-pro-shop .mcs-new-qty').val(24);
      $('.themin').text('24');
    } else {
      //console.log('its not white!');
      $('.qty-collection-pro-shop .mcs-new-qty').attr({ "min" : 24 });
      $('.qty-collection-pro-shop .mcs-new-qty').val(24);
      $('.themin').text('24');
    }

  });





  $('.mcs-close').click(function() {
    $('.announcement-bar').addClass('hide-bar');
  });




  // set of four toggles

  $('.set-of-four-btn').click(function(event) {
    // console.log('set of four clicked');
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    $('.product-form__item--submit').addClass("set-of-four-active");
    $('.product-form__item--submit').removeClass("individual-active");

    $('p.discount-note').show();
  });
  $('.individual-btn').click(function(event) {
    // console.log('individual clicked');
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    $('.product-form__item--submit').addClass("individual-active");
    $('.product-form__item--submit').removeClass("set-of-four-active");

    $('#Quantity-product-template').val('1');
    $('p.discount-note').hide();
  });

  $('.product-form__item--submit').click(function() {
    // console.log('hello world');
    if ( $(this).hasClass('set-of-four-active') ) {
     //alert("js is working");
      var value = $('#Quantity-product-template').val();
      var newvalue = value * 4
      // console.log(value);
      // console.log(newvalue);
      $('#Quantity-product-template').val(newvalue);
    }
  });



  $('.panel-landing div.panel-overlay').fadeOut(600);
  // guides panels restaurants
  $(".panel").click(function() {
    $(this).siblings().scrollTop(0);
    $(this).scrollTop(0);
    $(this).siblings().children('div.panel-overlay').show();
    $(this).siblings().removeClass('active'); 
    $(this).addClass('active');
    setTimeout(function() { 
       $('.panel.active div.panel-overlay').fadeOut(600);
    }, 400);
  });

  $(".rest-guide-open-menu").click(function() {
    $('.rest-guide-slideout').toggleClass('active');
  });
  $(".rest-guide-slideout .close-btn").click(function() {
    $(this).parent().removeClass('active');
  });


  $(".mobile-panels-toggle a").click(function() {
    var mypanel = $(this).attr('data-my-element');
    // console.log(mypanel);
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('.panel.' + mypanel).siblings().removeClass('active');
    $('.panel.' + mypanel).siblings().children('div.panel-overlay').show();
    $('.panel.' + mypanel).addClass('active');
    $('.panel.' + mypanel).scrollTop(0);
    setTimeout(function() { 
       $('.panel.' + mypanel +' div.panel-overlay').fadeOut(600);
    }, 400);
  });




    // FREE SHIPPING CALC
    var freeship = 10000


    // calculate percentage for bar
    // var tot = cart.total_price;
    var tot = parseInt($('.number').text());

    var diff = freeship - tot;
    var diff2 = diff / 100;

    console.log(tot);
    console.log(freeship);
    
    if ( tot >= freeship ) {
      //$('.tac2').addClass('active');
      console.log('freeship');
      $('.how-close').html( "You have qualified for free shipping." );
      $('.tac2').addClass('active');
      $('.progress-bar').css("width",  100 + "%");
    } else {
      var diffpercent = ( tot / freeship ) * 100;
      //console.log(diffpercent);
      $('.progress-bar').css("width",  diffpercent + "%");
      $('.how-close').html( "$" + diff2 + " away from free shipping");
    }





  // $('.set-of-four-btn').click(function() {
  //   $('#Quantity-product-template').val('4');
  //   $('p.discount-note').show();
  // });
  // $('.individual-btn').click(function() {
  //   $('#Quantity-product-template').val('1');
  //   $('p.discount-note').hide();
  // });


  $('#social-widget-wrapper').hide();
  setTimeout(function(){
    $('#social-widget-wrapper').show();
  }, 1000);
  setTimeout(function(){
    $('#social-widget-wrapper').addClass('ready-to-load');
  }, 2000); 


  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 30
          }, 1000);
          return false;
        }
      }
    });
  });

    
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
              self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  




});

$(window).on('load', function() {

  
    // disable hovers once tubmnails are being selected. 
  // $('.product-single__thumbnail-image').click(function() {
  //    $('img.mcs-product-hover').css({ "display": "none" });
  // });

  $('.product-single__thumbnails-item').click(function() {
    if ( $(this).hasClass('mcs-thumbnail-selector-1') ) {
      $('.mcs-product-hover').show();
    } else {
      $('.mcs-product-hover').hide();
    }
    
  });



  // $('.mcs-cart-upsells').flickity({
  //   wrapAround: true,
  //   pageDots: false,
  //   cellAlign: 'left',
  //   autoPlay: 5000,
  //   arrowShape: { 
  //     x0: 10,
  //     x1: 60, y1: 50,
  //     x2: 65, y2: 45,
  //     x3: 20
  //   }
  // });






});



